import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model): string =>
	item?.additionalFields?.customerNotes ?? item?.orderNote ?? "";

export default cellProcessing;
